import {
  RESET_SCHEDULE_RECURRING_INFO,
  SET_CALENDAR_OFFSET_BEFORE_NEW_VISIT,
  SET_CALENDAR_RANGE_BEFORE_NEW_VISIT,
  SET_ERROR,
  SET_IS_APPOINTMENT_POPUP_SHOWN,
  SET_IS_DELETE_CALENDAR_EVENT_SUCCESS,
  SET_IS_SUCCESS_SCHEDULE_EDIT,
  SET_LOADING,
} from './CalendarConstants'

export function setError(code = '', extra = null) {
  const action = {
    type: SET_ERROR,
    payload: { UserFriendlyErrorCode: code, extra },
  }
  return action
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setCalendarLoading(newStatus) {
  return {
    type: SET_LOADING,
    payload: newStatus,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setIsAppointmentPopUpInfoVisible(newState, selectedAppointment) {
  return {
    type: SET_IS_APPOINTMENT_POPUP_SHOWN,
    payload: newState,
    extraData: selectedAppointment,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsSuccessScheduleEdit = (newState) => ({
  type: SET_IS_SUCCESS_SCHEDULE_EDIT,
  payload: newState,
})
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsDeleteCalendarEventSuccess = (newState) => ({
  type: SET_IS_DELETE_CALENDAR_EVENT_SUCCESS,
  payload: newState,
})

export const resetScheduleInfoRecurring = () => ({
  type: RESET_SCHEDULE_RECURRING_INFO,
})

export const setCalendarRangeBeforeNewVisit = (value = null) => ({
  type: SET_CALENDAR_RANGE_BEFORE_NEW_VISIT,
  payload: value,
})
export const setCalendarOffsetBeforeNewVisit = (value = null) => ({
  type: SET_CALENDAR_OFFSET_BEFORE_NEW_VISIT,
  payload: value,
})
